// import { defineAsyncComponent } from 'vue';
// const Login = defineAsyncComponent(() => import('@/views/Login.vue'));

import { RouteRecordRaw, createRouter, createWebHistory } from 'vue-router'
import store from '@/store/'
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { Role } from '@/enum/roles.enum';
import adminRoutes from './roles/admin';
import cmpRoutes from './roles/company';
import projRoutes from './roles/project';
// import Layout from '@/layout/index.vue'
import Docs from '@/layout/header/reference.vue';


const whileList = ['/login', '/docs', '/docs/api','/model-viewer']

const routes = [
  {
    path: '/login',
    name: 'LoginPage',
    component: () => import('@/modules/login/index.vue'),
    meta: {
      requiresAuth: false // 访问该路由需要身份验证
    }
  },
  {
    path: '/docs',
    name: 'DocPage',
    component: Docs,
    meta: {
      requiresAuth: false,
      title: '文档资料',
      icon: ''
    },
    children: [
      {
        path: '',
        name: 'Api',
        component: () => import('@/modules/docs/api.vue'),
        meta: {
          requiresAuth: false,
          title: '接口协议',
          icon: 'Monitor'
        }
      },
    ]
  },
  {
    path: '/model-viewer',
    name: 'ModelViewer',
    component: () => import('@/modules/model-viewer/index.vue'),
    meta: {
      requiresAuth: false,
    }
  },
]

const ErrorRoutes = [
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('@/modules/404/index.vue'),
    meta: {
      requiresAuth: true, // 访问该路由需要身份验证
      title: '404',
      hidden: true,
    },
  },
  {
    path: '/:catchAll(.*)',
    name: 'Error',
    redirect: '/404',
    // component: () => import('@/modules/404/index.vue'),
    meta: {
      requiresAuth: false, // 访问该路由需要身份验证
      title: '错误页面',
    },
  }
]

const router = createRouter({
  // history: createWebHistory('/'),
  history: createWebHistory('/v1'), // 124 服务器部署调试工具目录路径
  routes,
})


export const generateRoutesByUserRole = (role: Role) => {
  // 移除现有的动态路由配置
  const userRoutes: RouteRecordRaw[] = [];
  if (role === Role.Admin) {
    // 更新路由配置
    userRoutes.push(...adminRoutes, ...ErrorRoutes);
    // // 动态添加路由
  } else if (role.startsWith('Cmp')) {
    userRoutes.push(...cmpRoutes, ...ErrorRoutes);
  } else if (role.startsWith('Proj')) {
    userRoutes.push(...projRoutes, ...ErrorRoutes);
  } else {
    userRoutes.push(...ErrorRoutes);
  }
  userRoutes.forEach((route: RouteRecordRaw) => {
    router.addRoute(route);
  });
  router.options.routes = userRoutes;
}


router.beforeEach(async (to, from, next) => {
  if (to.path === '/login' || whileList.includes(to.path)) {
    next()
  } else {

    //  刷新重置路由
    if (!store.state.user.role) {
      await store.dispatch('user/getProfile')
      router.replace(to.path)
    }

    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    // const isAuthenticated = localStorage.getItem('token');
    // console.log(requiresAuth, isAuthenticated)
    // if (requiresAuth) {
    // if (!isAuthenticated) {
    //   // 页面需要登录，且处于未登录状态 
    //   next('/login');
    // } else {
    //   next()
    // }
    // } else {
    // }
    if (requiresAuth) {
      // 刷新逻辑，需要重新获取用户信息
      if (!store.state.user.name) {
        await store.dispatch('user/getProfile')
      }
    }
    next();
  }

});


// NProgress 加载插件
NProgress.configure({
  template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="loading-text">…</div><div class="spinner-icon"></div></div>'
});
router.beforeEach((to, from, next) => {
  // 登录页面 不显示加载动画
  if (![from.name, to.name].includes("LoginPage")) {
    NProgress.start();
  }
  next();
});
router.afterEach(() => {
  NProgress.done();
});


export default router